import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/brand/Logo";
import { toast } from "sonner";

export default function SignupPage() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      const created = await signup(email, password, name);
      if (!created) {
        toast.message("Check your inbox to continue.", { description: "If this email is already registered, sign in or reset your password." });
        navigate("/login");
        return;
      }
      toast.success("Account created. Let's get your growth plan.");
      navigate("/onboarding");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark-marketing grain min-h-screen flex items-center justify-center px-6" data-testid="signup-page">
      <div className="absolute top-6 left-6">
        <Link to="/"><Logo variant="light" /></Link>
      </div>
      <div className="w-full max-w-md glass rounded-sm p-8">
        <p className="editorial-overline">Begin compounding</p>
        <h1 className="font-serif text-3xl text-ivory-50 mt-3">Create your TrendRise AI account</h1>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-ivory-200/60">Name</label>
            <input
              data-testid="signup-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="mt-2 w-full bg-transparent border border-ivory-200/20 px-4 py-3 text-ivory-50 rounded-sm focus:border-gold-500 outline-none"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-ivory-200/60">Email</label>
            <input
              data-testid="signup-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-2 w-full bg-transparent border border-ivory-200/20 px-4 py-3 text-ivory-50 rounded-sm focus:border-gold-500 outline-none"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-ivory-200/60">Password (min 6 chars)</label>
            <input
              data-testid="signup-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 w-full bg-transparent border border-ivory-200/20 px-4 py-3 text-ivory-50 rounded-sm focus:border-gold-500 outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="signup-submit"
            className="w-full bg-gold-500 hover:bg-gold-400 text-navy-900 font-semibold rounded-sm py-3 transition-colors disabled:opacity-50"
          >
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="text-xs text-ivory-200/60 mt-6">
          Already have an account?{" "}
          <Link to="/login" className="text-gold-500" data-testid="signup-to-login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
